import { gql } from '@apollo/client';

export const GET_TIMELINE_TAB_DATA = gql`
  query GetProjectTimelineData($id: ID!) {
    baseProject(id: $id) {
      id
      timeline {
        id
        projectId
        type
        payload {
          ... on NotePayload {
            text
            attachmentPaths
          }
          ... on ProjectCompletionPayload {
            status
            totalHoursSpent
            deliveryDate
            links {
              type
              url
            }
            text
          }
          ... on SummaryReviewPayload {
            reviewId
            startDate
            endDate
            reviewer
          }
        }
        isPinned
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;
